import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dowloadedMessage", "loadingMessage", "bulkSearchMessage", "downloadURL"]

  static values = { finished: Boolean }

  connect() {
    var _this = this

    setInterval(function () {
      if (_this.finishedValue) {
        return
      }

      if (window.location.href.includes("technologies/domains_lists") == false) {
        _this.finishedValue = true
        return
      }

      fetch(window.location.href + ".json", {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.available == true && _this.loadingMessageTarget.classList.contains("d-none") == false) {
            window.location.href = response.url

            _this.downloadURLTarget.href = response.url
            _this.loadingMessageTarget.classList.add("d-none")
            _this.dowloadedMessageTarget.classList.remove("d-none")
            _this.bulkSearchMessageTarget.classList.remove("d-none")

            // We save a value at the controller level to prevent this loop from
            // going on forever.
            _this.finishedValue = true
          }
        })
    }, 2000)
  }
}
